// extracted by mini-css-extract-plugin
export default {"seperatorContainer":"qSTFJG9JkUfK5NR5kBlZ"};